import { Notice } from "../../shared/components"
import { useCursorData } from "../contexts/CursorDataContext"

import type { Options } from "../types/Options"

// What the visitor should know about the source they picked.
export const SourceNotices = () => {
  const {
    source,
    loadError,
    options,
    isConverting,
    changeOptions,
    dismissSuggestion,
    clearLoadError,
  } = useCursorData()
  const suggests = (option: keyof Options) => {
    const suggested = source?.suggestions[option]
    return suggested !== undefined && options[option] !== suggested
  }

  return (
    <>
      {loadError && (
        <Notice tone="error" onDismiss={clearLoadError}>
          {loadError}
        </Notice>
      )}
      {suggests("removeBackground") && (
        <Notice
          tone="warning"
          action={{
            label: "Remove it",
            onClick: () => changeOptions({ ...options, removeBackground: true }),
            // Like the options column, so the upload in flight saves what's on screen.
            disabled: isConverting,
          }}
          onDismiss={() => dismissSuggestion("removeBackground")}
        >
          Looks like a solid background. Cursors want a transparent one.
        </Notice>
      )}
      {suggests("framing") && !options.trim && (
        <Notice
          tone="info"
          action={{
            label: "Fill & crop",
            onClick: () => changeOptions({ ...options, framing: "fill" }),
            disabled: isConverting,
          }}
          onDismiss={() => dismissSuggestion("framing")}
        >
          Not square — it&apos;s fitted with empty space around it. Fill zooms in instead.
        </Notice>
      )}
    </>
  )
}
